import React from 'react';
import Classes from "classnames";

import {INLINE_STYLE} from "draftail";
import InlinePopoverOptions from "./inline-popover-options";
import PopupMenuButton from "src/core/gd-components/popover-menu/popup-menu-button/popup-menu-button";

export default function InlineOptions(props) {

    const button = () => <div className="ui5-arrow-toggle s8 open"/>

    const classes = Classes('ui5-control-button s-26', {
        'selected':
            props.currentStyles.has(INLINE_STYLE.STRIKETHROUGH) ||
            props.currentStyles.has(INLINE_STYLE.CODE) ||
            props.currentStyles.has(INLINE_STYLE.SUBSCRIPT) ||
            props.currentStyles.has(INLINE_STYLE.SUPERSCRIPT)
    })

    return (
        <PopupMenuButton className={classes}
                         hint="Inline styles options"
                         btnComponent={button}
                         menuComponent={InlinePopoverOptions}
                         menuParams={{
                             currentStyles:     props.currentStyles,
                             toggleInlineStyle: props.toggleInlineStyle
                         }}/>
    )
}
